import { useQuery } from '@tanstack/react-query';

import { getChats } from '../../../api/chats';
import { useAuth } from '../../auth/AuthProvider';

export function useChats(search?: string) {
  const { tokens } = useAuth();

  return useQuery({
    queryKey: ['admin-chats', search ?? ''],
    queryFn: () => getChats(tokens!.access_token, search),
    enabled: Boolean(tokens?.access_token),
  });
}
